import {
	ImageryLayer,
	WebMapTileServiceImageryProvider,
	Credit,
	TileMapServiceImageryProvider,
	WebMercatorTilingScheme,
	TileProviderError
} from 'cesium';

const tileMatrixSetID = 'webmercator';
const tileMatrixSetLabels: string[] = [...Array(19)].map((_, i) => `webmercator:${i}`);

const topo4GraaLayer = new ImageryLayer(
	new WebMapTileServiceImageryProvider({
		url: 'https://cache.kartverket.no/v1/wmts/1.0.0/topograatone/default/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}.png',
		layer: 'topograatone',
		style: 'default',
		format: 'image/png',
		tileMatrixSetID,
		//tileMatrixLabels: tileMatrixSetLabels,
		maximumLevel: 18,
		credit: new Credit('Kartverket')
	}),
	{}
);

const topo4Layer = new ImageryLayer(
	new WebMapTileServiceImageryProvider({
		url: 'https://cache.kartverket.no/v1/wmts/1.0.0/topo/default/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}.png',
		layer: 'topo',
		style: 'default',
		format: 'image/png',
		tileMatrixSetID,
		//tileMatrixLabels: tileMatrixSetLabels,
		maximumLevel: 18,
		credit: new Credit('Kartverket')
	}),
	{}
);

let nibLayer: ImageryLayer;

/*
topo4Layer.imageryProvider.errorEvent.addEventListener((e: TileProviderError) => {

	 Suppressing non-server errors 
});
*/
/**
 * Util for simple import (into other files) of integrated WMTS map layers.
 */
const getWMTSImageryMapLayers = () => {
	return { topo4Layer, topo4GraaLayer };
};
/*
const getNibLayer = () => {
    if (!nibLayer) {
        nibLayer = new ImageryLayer(
            new WebMapTileServiceImageryProvider({
                url: 'https://opencache.statkart.no/gatekeeper/gk/gk.open_nib_web_mercator_wmts_v2?SERVICE=WMTS',
                layer: 'Nibcache_web_mercator_v2',
                style: 'default',
                format: 'image/png',
                maximumLevel: 19,
                tileMatrixSetID: `default028mm`,
                tileMatrixLabels: [...Array(20)].map((_, i) => i),
                credit: new Credit('Kartverket')
            }),
            {}
        );
		nibLayer.imageryProvider.errorEvent.addEventListener((e: TileProviderError) => {
			if(e.timesRetried === 0) {
				console.warn('Tile provider error:', e);
			}
		});
    }
    return nibLayer;
};*/

const getWMTSOrtofotoAsync = async () => {
	return new ImageryLayer(
		await TileMapServiceImageryProvider.fromUrl(
			'https://waapi.webatlas.no/wms-orto/tms/ortofoto_pri_up_200_8_3857_256/?api_key=06be3cd6-2849-49ef-8baf-429acc040709',
			{
				fileExtension: 'jpg',
				tilingScheme: new WebMercatorTilingScheme({}),
				maximumLevel: 20,
				credit:
					'Norkart AS, Sentinel-2 cloudless – https://s2maps.eu by EOX IT Services GmbH (Contains modified Copernicus Sentinel data 2016 & 2017), Geovekst og kommunene'
			}
		),
		{}
	);
};

export { getWMTSImageryMapLayers, getWMTSOrtofotoAsync /*, getNibLayer */ };
